import { getRgObjectsOfType as u, RG_TYPE as r } from "@project-rouge/rg-core";
function a(i, o = !0) {
  let e = 0;
  const s = u(i, r.Building);
  for (const f of s) {
    let t = f.data.levels;
    o === !1 && (t = t.filter(({ isRoof: l }) => !l));
    const n = new Set(t.map((l) => l.levelIndex)).size;
    e < n && (e = n);
  }
  return e;
}
export {
  a as getLevelCount
};
//# sourceMappingURL=index3.js.map
